
export default () => ({
  researchForm: {},
  form: {
    flightVariantId: null,
    hotelVariantId: null,
    transferVariantId: null,
    insuranceVariantId: null,
    visaVariantId: null,
    tourTemplateId: 1,
    tourType: null,
  }
})